<div class="progress" [ngClass]="{'d-none':!isIndeterminate}">
  <div class="indeterminate" ></div>
</div>